import type { FunctionComponent } from 'react';
import { List } from '@george-labs.com/design-system';

import type { FlatArrayFeature } from './types';
import { FeatureListItem } from './FeatureListItem';
import styles from './FeatureList.module.scss';

interface FeatureListProps {
    features: FlatArrayFeature[];
}

export const FeatureList: FunctionComponent<FeatureListProps> = ({ features }) => (
    <List variant={List.VARIANT.PLAIN} className={`px-1 py-2 ${styles.featureList}`}>
        {features.map((flag) => (
            <FeatureListItem key={flag.name} flag={flag} />
        ))}
    </List>
);
